<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :loading="loading"
      :columns="tableColumns"
      :height="300"
      :toolbar-config="tableToolbar"
      size="mini"
      border
      resizable
      :edit-rules="validRules"
      :edit-config="{
        trigger: 'click',
        mode: 'row',
        activeMethod: activeCellMethod,
      }"
      @edit-closed="save"
      :show-footer="false"
      :footer-method="footerMethod"
    >
      <template v-slot:toolbar_form>
        <slot name="header"> </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            v-if="!disabled && packingType === 'A'"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span class="spStyle"> 输入的批次数量 {{ this.param.qty }} 个</span>
      <span class="spStyle"> 会产生{{ this.param.surplusQty }}个尾箱数量</span>
      <span class="spStyle">
        已自动转换整箱批次数量 {{ this.param.newQty }}个</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="() => (backDialogVisible = false)"
          type="primary"
          size="mini"
          >{{ '确认' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import Math from '@/libs/util.math.js'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: {
      type: Boolean,
      default: false,
    },
    packingType: { type: String, default: 'A' },
  },
  data() {
    return {
      showBox: false,
      visibale: false,
      backDialogVisible: false,
      tableColumns: tableColumns(this),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      validRules: {
        qty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.table_pe_Please_enter_quantity') || '请输入数量',
          },
        ],
      },
      param: {
        qty: 0,
        newQty: 0,
        surplusQty: 0,
      },
    }
  },
  computed: {
    footerData() {
      if (!this.tableData) return 0
      var qty = 0
      this.tableData.forEach((i) => (qty += i.qty))
      return [['合计', '', '', '', '', qty.toFixed(0), '', '']]
    },
    tableRef() {
      return this.$refs.table
    },
  },
  methods: {
    footerMethod() {
      // 返回一个二维数组的表尾合计
      return this.footerData
    },
    activeCellMethod({ columnIndex }) {
      if (this.packingType === 'B') {
        if (columnIndex === 5) {
          return false
        }
      }
      return true
    },
    del(row) {
      let index = this.$refs.table.getRowIndex(row)
      this.tableData.splice(index, 1)
      let param = { totQty: 0, totBoxQty: 0 }
      this.tableData.forEach((i) => {
        param.totQty += i.qty ? i.qty : 0
        param.totBoxQty += i.boxQty ? i.boxQty : 0
      })
      this.$emit('saveQty', param)
    },

    async getTableData() {
      const result = await this.validEvent()
      if (!result) return result
      return this.$refs.table.getTableData()
    },
    async validEvent() {
      const $table = this.$refs.table
      const errMap = await $table.validate(true).catch((errMap) => errMap)
      if (errMap) {
        return false
      } else {
        return true
      }
    },
    updateTable(val) {
      if (val === 'B') {
        this.$refs.table.hideColumn(this.$refs.table.getColumnByField('boxQty'))
      } else {
        this.$refs.table.showColumn(this.$refs.table.getColumnByField('boxQty'))
      }
      this.tableRef.refreshColumn()
    },
    save({ row }) {
      var boxQty = this.roundDown(this.divide(row.qty, row.inPackageQty), 0)
      var newQty = this.multiply(boxQty, row.inPackageQty)
      if (newQty != row.qty) {
        this.param.newQty = newQty
        this.param.qty = row.qty
        this.param.surplusQty = row.qty - newQty

        this.backDialogVisible = true
        // this.$confirm(
        //   '输入的批次数量' +
        //     row.qty +
        //     '个，会产生' +
        //     (row.qty - newQty) +
        //     '个尾箱数量，已自动转换整箱批次数量 ' +
        //     newQty +
        //     ' 个',
        //   this.$l('INDEX.label_completeDesc') || '确认信息',
        //   {
        //     confirmButtonText:
        //       this.$l('INDEX.product_dialog_btn_confirm') || '确定',
        //   }
        // )
      }
      row.qty = newQty
      row.boxQty = boxQty
      const data = this.$refs.table.getTableData().tableData
      let param = { totQty: 0, totBoxQty: 0 }
      data.forEach((i) => {
        param.totQty += i.qty ? i.qty : 0
        param.totBoxQty += i.boxQty ? i.boxQty : 0
      })
      this.$emit('saveQty', param)
    },
    roundDown(x, y) {
      if (!x) return 0
      const fixed = Math.pow(10, y)
      return this.divide(Math.floor(this.multiply(x, fixed)), fixed)
    },
    multiply(x, y) {
      if (!x || !y) return 0
      return Math.number(Math.multiply(Math.bignumber(x), Math.bignumber(y)))
    },
    divide(x, y) {
      if (!y) return 0
      return Math.number(Math.divide(Math.bignumber(x), Math.bignumber(y)))
    },
    updateTotBoxQty(val) {
      this.tableData.forEach((i) => (i.qty = i.inPackageQty * val))
      const data = this.$refs.table.getTableData().tableData
      let param = { totQty: 0, totBoxQty: val }
      data.forEach((i) => {
        param.totQty += i.qty ? i.qty : 0
      })
      this.$emit('saveQty', param)
    },
  },
}
</script>
<style scoped>
.spStyle {
  text-align: center;
  display: block;
  line-height: 28px;
}
</style>
